import * as React from "react";
import { MenuButtonProps } from "../../types";
import "./MenuButtonStyles.scss";
import { noop } from "../../../helpers";

/**
 * Animated hamburger menu toggle button. Manages its own open/closed state
 * and calls `onClick` on every toggle.
 *
 * @example
 * ```tsx
 * <MenuButton
 *   size="medium"
 *   openLabel="Menu"
 *   closeLabel="Close"
 *   onClick={handleNavToggle}
 * />
 * ```
 */
const MenuButton: React.FC<MenuButtonProps> = ({
  size,
  onClick = noop,
  openLabel,
  closeLabel,
  className,
}) => {
  const [isActive, setIsActive] = React.useState(false);

  const handleOnClick = () => {
    setIsActive(!isActive);
    onClick();
  };

  return (
    <div
      onClick={() => handleOnClick()}
      className={`cp-menu-button-wrapper ${className}`}
    >
      <div className="cp-menu-button-label">
        {isActive ? closeLabel : openLabel}
      </div>
      <div
        className={`cp-menu-button ${size ?? ""} ${isActive ? "active" : ""}`}
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default MenuButton;
